/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningDtosVacationAdjustVacationEntitlementRequest,
  FacilityFlowCoreModulesPlanningDtosVacationVacationBalanceDto,
  GetApiV1EmployeesEmployeeIdVacationBalanceParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getEmployeeVacation = () => {
/**
 * @summary Vacation balance for the vacation year containing referenceDate
(today when omitted).
 */
const getApiV1EmployeesEmployeeIdVacationBalance = (
    employeeId: string,
    params?: GetApiV1EmployeesEmployeeIdVacationBalanceParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosVacationVacationBalanceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosVacationVacationBalanceDto>(
      {url: `/api/v1/employees/${employeeId}/vacation-balance`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Apply a manual correction to the employee's entitlement for the given vacation year.
 */
const postApiV1EmployeesEmployeeIdVacationEntitlementsCurrentAdjust = (
    employeeId: string,
    facilityFlowCoreModulesPlanningDtosVacationAdjustVacationEntitlementRequest: FacilityFlowCoreModulesPlanningDtosVacationAdjustVacationEntitlementRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosVacationVacationBalanceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosVacationVacationBalanceDto>(
      {url: `/api/v1/employees/${employeeId}/vacation-entitlements/current/adjust`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosVacationAdjustVacationEntitlementRequest
    },
      options);
    }
  return {getApiV1EmployeesEmployeeIdVacationBalance,postApiV1EmployeesEmployeeIdVacationEntitlementsCurrentAdjust}};
export type GetApiV1EmployeesEmployeeIdVacationBalanceResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployeeVacation>['getApiV1EmployeesEmployeeIdVacationBalance']>>>
export type PostApiV1EmployeesEmployeeIdVacationEntitlementsCurrentAdjustResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployeeVacation>['postApiV1EmployeesEmployeeIdVacationEntitlementsCurrentAdjust']>>>
